import { render } from "./MenuFarm.vue?vue&type=template&id=1de87ecc&scoped=true"
import script from "./MenuFarm.vue?vue&type=script&lang=js"
export * from "./MenuFarm.vue?vue&type=script&lang=js"

import "./MenuFarm.vue?vue&type=style&index=0&id=1de87ecc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1de87ecc"]])

export default __exports__